import React from 'react'
import HeroBlock from 'gatsby-theme-kn/src/components/blocks/HeroBlock'
import SocialShareBlock from 'gatsby-theme-kn/src/components/blocks/SocialShareBlock'
import Layout from 'gatsby-theme-kn/src/components/modules/Layout'
import BodyBlocks from 'gatsby-theme-kn/src/components/technical/BodyBlocks'
import { Helmet } from 'react-helmet'
import SidebarModule from 'gatsby-theme-kn/src/components/modules/SidebarModule'
import SEO from 'gatsby-theme-kn/src/components/modules/Seo'

const ContentPage = ({ locale, content, name, alternates }) => {
  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} title={name} />
        <HeroBlock
          useStoryblokImage
          block={{
            headline: content.headline?.length > 0 ? content.headline : name,
            image: content.header_image,
            reduced_height: content.reduced_height,
          }}
        />
        <SocialShareBlock />
        {/* <section className="content-block-full-width">
          <div className="content-block-one-col-body"> */}
        <section className={`content-sidebar-layout `}>
          <div className="content-sidebar-layout-body">
            <div className="content-sidebar-layout-body-row">
              <div className="content-sidebar-layout-body-content">
                <BodyBlocks body={content.body} />
              </div>
              <div className="content-sidebar-layout-body-sidebar">
                <SidebarModule
                  gri_numbers={content.gri_numbers}
                  news_relations={content.news_relations}
                  downloads={content.downloads}
                  links={content.links}
                  articles={content.content_page_relations}
                />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </div>
  )
}

export default ContentPage
